module.exports = __webpack_public_path__ + "img/m_video_rule.fa338988.png";